import { Consumer } from "Models/consumer";

export const getConsumers = (state: any): Consumer[] => state.consumers;
export const getLeadConsumers =
    (leadId: number) =>
    (state: any): Consumer[] =>
        state.consumers?.filter((c: Consumer) => c.leads.includes(leadId)) ??
        [];
